<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 09:38:40
 * @LastEditors: mobai
 * @LastEditTime: 2022-11-11 15:10:56
-->
<template>
  <div class="contain">
    <!-- <section class="head">
      <img src="@/assets/images/biaoqian.png" alt="" />
    </section> -->
    <section class="box" v-if="!creditCode">
      <template v-if="labelList.length">
        <div class="topLabel">
          <div class="label-box">
            <span
              :class="['label-box-item', currentIndex == index ? 'active' : '']"
              v-for="(item, index) in labelList"
              :key="index"
              @click="clickLabelViewInfo(item, index)"
            >
              {{ item.name }}
            </span>
          </div>
        </div>
        <!-- <div class="box_head">{{ label.name }}</div> -->
        <div
          class="box_content"
          v-html="labelList.length ? labelList[currentIndex].remark : ''"
        ></div>
      </template>
      <div class="entStyle-empty" v-else>
        <img src="@/assets/images/暂无数据.png" alt="" />
        <div class="empty-msg">暂无数据</div>
      </div>
    </section>
    <section
      class="box"
      v-else
      :style="{
        'background-image': `url(${require('@/assets/images/' +
          bgImgUrl +
          '.png')})`
      }"
    >
      <div class="box-header">
        <div class="box-header-title">
          <div>
            <div>{{ entData.entName }}</div>
            <div>法人：{{ entData.frName }}</div>
            <div>统一社会信用代码：{{ entData.creditCode }}</div>
          </div>
          <img src="@/assets/images/企业icon@2x.png" alt="" />
        </div>
        <div class="box-header-address">注册地址：{{ entData.address }}</div>
        <div class="box-header-label">
          <div v-for="item in labelName" :key="item">{{ item }}</div>
        </div>
      </div>
      <div class="box-body">
        <div class="box-body-title">基本信息</div>
        <div class="box-body-text">
          <div class="box-body-text-information">
            <div>
              <div>所在区域</div>
              <div>
                {{ toHtmlStr(business.province) }}{{ toHtmlStr(business.city)
                }}{{ toHtmlStr(business.county) }}
              </div>
            </div>
            <div>
              <div>注册资本</div>
              <div>{{ business.regCap }}</div>
            </div>
          </div>
          <div class="box-body-text-information">
            <div>
              <div>经营状态</div>
              <div>{{ entData.entStatus || '-' }}</div>
            </div>
            <div>
              <div>企业类型</div>
              <div>{{ entData.entType || '-' }}</div>
            </div>
          </div>
          <div class="box-body-text-information active">
            <div>
              <div>行业门类名称</div>
              <div>{{ business.industryPhyName || '-' }}</div>
            </div>
          </div>
          <div class="box-body-text-information active brief">
            <div>
              <div>公司简介</div>
              <div>
                {{ entData.brief || '-' }}
              </div>
            </div>
          </div>
          <div class="box-body-text-information active">
            <div>
              <div>企业风采</div>
              <div class="video">
                <div v-if="videos && videos.length" class="imgList">
                  <div v-for="item in videos" :key="item.ossUrl">
                    <div class="imgOrVideo" v-if="item.fileType == 3">
                      <video
                        :src="item.ossUrl"
                        class="avatar"
                        controls="controls"
                        controlslist="nodownload noremoteplayback noplaybackrate"
                        disablePictureInPicture
                        loop
                      >
                        您的浏览器不支持视频播放
                      </video>
                    </div>
                    <div class="imgOrVideo" v-if="item.fileType == 1">
                      <el-image
                        :src="item.ossUrl"
                        :preview-src-list="[item.ossUrl]"
                      />
                    </div>
                  </div>
                </div>
                <div class="entStyle-empty" v-else>
                  <img src="@/assets/images/暂无数据.png" alt="" />
                  <div class="empty-msg">暂无数据</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-foot" @click="onGet">
        查看更多
        <img src="@/assets/查看更多-线.svg" alt="" />
      </div>
    </section>
  </div>
</template>

<script>
import { toHtmlStr } from '@utils'
import { getEntDetail, getEntOpen } from '@api/corporateInteraction/enterprise'
export default {
  props: {
    // label: {
    //   type: Object,
    //   default: () => {
    //     return { name: '', remark: '' }
    //   }
    // },
    labelList: {
      type: Array,
      default: () => []
    },
    creditCode: {
      type: String,
      default: ''
    },
    entName: {
      type: String,
      default: ''
    },
    selectLabelIdList: {
      type: Array,
      default: () => []
    }
  },
  computed: {},
  components: {},
  data() {
    return {
      toHtmlStr,
      entData: {},
      labelName: [],
      business: {},
      videos: [],
      pictures: [],
      srcList: [],
      currentIndex: 0, // 选中项标签解读
      bgImgUrl: 'right-label'
    }
  },
  watch: {
    creditCode(val) {
      if (val) {
        this.getEntOpen()
        this.getEntInformation(val)
      }
      this.bgImgUrl = val ? 'right-entInfo' : 'right-label'
    }
    // selectLabelIdList(val) {
    //   this.currentIndex = val.length - 1
    // }
  },
  created() { },
  mounted() { },
  methods: {
    clickLabelViewInfo(data, index) {
      this.currentIndex = index
    },
    getEntInformation(val) {
      getEntDetail({ creditCode: val }).then(res => {
        if (res.data.code == '0000') {
          this.videos = res.data.data.videos || []
          this.pictures = res.data.data.pictures || []
          this.entData = res.data.data.entData || {}
          this.labelName = res.data.data.labelName || []
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    /** 获取工商信息 */
    getEntOpen() {
      getEntOpen({
        creditCode: this.creditCode,
        entName: this.entName
      }).then(res => {
        if (res.data.code == '0000') {
          this.business = res.data.data
          this.business.regCap = this.business.regCap
            ? this.business.regCap + '万元'
            : '-'
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onGet() {
      // this.$emit('openEnt')
      this.$router.push({
        name: 'cominfo',
        query: {
          creditCode: this.entData.creditCode,
          entName: this.entData.entName
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contain {
  width: 4.4rem;
  height: calc(100% - 0.6rem);
  .head {
    text-align: center;
    height: 0.6rem;
    line-height: 0.6rem;
    img {
      width: 100%;
    }
  }
  .box {
    margin-top: 0.3rem;
    width: inherit;
    padding: 0.64rem 0.3rem;
    height: 100%;
    background: url('~@/assets/images/right-label.png') no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    position: relative;
    .label-box {
      color: rgba(199, 241, 255, 100);
      font-size: 16px;
      width: 3.6rem;
      overflow-x: auto;
      white-space: nowrap;
      &-item {
        display: inline-block;
        margin-right: 0.08rem;
        border-radius: 2px;
        background-color: rgba(0, 127, 255, 0.2);
        cursor: pointer;
        padding: 0.04rem 0.06rem;
        &.active {
          background-color: rgba(0, 127, 255, 1);
        }
      }
    }
    .box_head {
      text-align: center;
      color: rgba(0, 255, 254, 100);
      font-size: 0.2rem;
      margin-top: 0.1rem;
    }
    .box_content {
      height: 95%;
      overflow: auto;
      margin-top: 0.16rem;
      color: rgba(199, 241, 255, 100);
      font-size: 0.16rem;
      line-height: 0.3rem;
    }
    .box-header {
      color: rgba(199, 241, 255, 85);
      font-size: 0.14rem;
      padding: 0.2rem 0 0.1rem;
      border-bottom: 0.02rem solid rgba(168, 211, 231, 0.3);
      .box-header-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.08rem;
        & > div {
          & > div:nth-child(1) {
            color: rgba(0, 255, 254, 100);
            font-size: 0.2rem;
          }
          & > div:nth-child(2) {
            margin: 0.08rem 0;
          }
        }
        img {
          width: 0.6rem;
        }
      }
    }
    .box-header-address {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .box-header-label {
      margin-top: 0.08rem;
      display: flex;
      flex-wrap: wrap;
      & > div {
        margin-bottom: 0.05rem;
        margin-right: 0.08rem;
        padding: 0.05rem 0.08rem;
        border: 0.01rem solid rgba(255, 255, 255, 0.25);
      }
    }
    .box-body {
      margin-top: 0.2rem;
      color: rgba(199, 241, 255, 85);
      font-size: 0.14rem;
      height: calc(100% - 2.5rem);
      overflow-y: auto;
      .box-body-title {
        color: rgba(255, 255, 255, 100);
        font-size: 0.18rem;
        line-height: 0.26rem;
        &::before {
          content: '';
          vertical-align: middle;
          width: 0.03rem;
          height: 0.18rem;
          display: inline-block;
          margin-right: 0.1rem;
          background: #00fffe;
        }
      }
      .box-body-text {
        .box-body-text-information {
          display: flex;
          margin-top: 0.1rem;
          > div {
            width: 50%;
            font-size: 0.16rem;
            > div:nth-child(1) {
              color: #00fffe;
              margin-bottom: 0.08rem;
            }
          }
        }
        .active {
          > div {
            width: 100%;
          }
          .video {
            width: 100%;
            overflow: hidden;
            /* > div {
              display: flex;
              float: left; // 使其脱离文档流 宽度为所有字元素的和
              min-width: 100%;
              > div {
                width: 1.75rem;
                box-sizing: border-box;
                float: left;
                margin-right: 0.1rem;
                height: 1rem;
                video {
                  width: 100%;
                  height: 1rem;
                }
                /deep/ .el-image {
                  width: 100%;
                  height: 1rem;
                }
              }
            } */

            .imgList {
              display: flex;
              flex-wrap: wrap;
              margin-bottom: 0.2rem;
              .imgOrVideo {
                margin-right: 0.1rem;
                margin-bottom: 0.1rem;
                .el-image {
                  width: 1.75rem;
                  height: 1rem;
                }
              }
              .avatar {
                width: 1.75rem;
                height: 1rem;
                object-fit: cover; // 自定义宽高
              }
            }
          }
        }
        .brief {
          & > div {
            & > div:nth-child(2) {
              font-size: 0.14rem;
              line-height: 0.24rem;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 5;
              overflow: hidden;
            }
          }
        }
      }
    }
    .box-foot {
      cursor: pointer;
      width: 80%;
      height: 0.44rem;
      border-radius: 0.24rem;
      line-height: 0.44rem;
      text-align: center;
      color: rgba(255, 255, 255, 100);
      font-size: 0.14rem;
      background: linear-gradient(
        to right,
        rgba(0, 114, 223, 1),
        rgba(0, 114, 223, 0.54)
      );
      position: absolute;
      left: 10%;
      bottom: 0.4rem;
      > img {
        vertical-align: middle;
        margin-left: 5px;
      }
    }
  }
}
.entStyle-empty {
  padding: 0.5rem 0.32rem 0.24rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    width: 0.72rem;
    height: 0.77rem;
  }
  .empty-msg {
    line-height: 0.22rem;
    height: 0.22rem;
    margin-top: 0.08rem;
    color: rgba(0, 255, 254, 100);
    font-size: 0.14rem;
    text-align: center;
    font-family: PingFangSC-Regular;
  }
}
.box_content {
  ::-webkit-scrollbar {
    display: none !important;
  }
}
.topLabel {
  ::-webkit-scrollbar {
    width: 6px;
    height: 4px !important;
    display: block;
  }
  ::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.5) !important;
    border-radius: 10px;
    box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.3) !important;
    opacity: 0.5;
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
  }
}
//全屏按钮
video::-webkit-media-controls-fullscreen-button {
  display: none;
}
//进度条
video::-webkit-media-controls-timeline {
  display: none;
}
//观看的当前时间
video::-webkit-media-controls-current-time-display {
  display: none;
}
//剩余时间
video::-webkit-media-controls-time-remaining-display {
  display: none;
}
//音量按钮
video::-webkit-media-controls-mute-button {
  display: none;
}
video::-webkit-media-controls-toggle-closed-captions-button {
  display: none;
}
//音量的控制条
video::-webkit-media-controls-volume-slider {
  display: none;
}
</style>
